module.exports = __webpack_public_path__ + "static/media/atlweek.29c23418.PNG";